import React from 'react'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { Card, CardContent, CardHeader, Separator } from '@/shared/ui'

export default function DashboardMasterPage() {
  const { user, profile } = useAuth()
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Dashboard Master</h1>
      <p className="mt-1 text-sm text-foreground/70">Bem-vindo, {profile?.full_name || user?.email}</p>
      <Separator className="my-6" />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <Card>
          <CardHeader className="text-sm font-medium">Usuários Membros</CardHeader>
          <CardContent>
            <div className="text-3xl font-semibold">—</div>
            <div className="text-xs text-foreground/70">Total de contas registradas</div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="text-sm font-medium">Atividades</CardHeader>
          <CardContent>
            <div className="text-3xl font-semibold">—</div>
            <div className="text-xs text-foreground/70">Últimas 24h</div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="text-sm font-medium">Estado do Sistema</CardHeader>
          <CardContent>
            <div className="text-3xl font-semibold">OK</div>
            <div className="text-xs text-foreground/70">Serviços essenciais</div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

